import { parseUrlSafe } from '@fabric-app/business/expandedResource/expandedResource.utils';

export function openNativeMobileApp(deepLink: string, fallbackUrl: string): void {
  const url = parseUrlSafe(fallbackUrl);
  if (!url) {
    window.location.href = fallbackUrl;
    return;
  }

  // Disable deep linking for now
  // https://discord.com/channels/934045073002364981/1331251484675018816/1331254718277619752
  // The use case for deep linking was as a fallback for universal link on in-app browsers in iOS, but no longer
  // necessary as we now have the signup flow with web sockets, to be seen if this will be necessary in the future or not.
  //url.searchParams.set('deeplinkFallback', deepLink);

  window.location.href = url.toString();
}
